import { UploadProgress } from './uploadProgressStorage';

export function mapPipelineStatus(rawStatus: string): UploadProgress['status'] {
  switch (rawStatus) {
    case 'connected': return 'connected';
    case 'queued': return 'warming_up';
    case 'succeeded': return 'completed';
    case 'failed':
    case 'error': return 'failed';
    case 'cancelled':
    case 'canceling': return 'cancelled';
    default: return 'processing';
  }
}

export function isTerminalStatus(status: UploadProgress['status']): boolean {
  return ['completed', 'failed', 'cancelled'].includes(status);
}
